// Abre a obra no Ampli Obras em nova guia. Sem id da obra não há destino: não renderiza nada.
const AmpliObrasLink = ({ wbsBuildingId, className, children }) => {
  if (!wbsBuildingId) return null;
  return <a
    className={className}
    href={`/dashboard/${encodeURIComponent(wbsBuildingId)}`}
    target="_blank"
    rel="noopener noreferrer"
    onClick={(event) => event.stopPropagation()}
    onKeyDown={(event) => event.stopPropagation()}
  >
    {children}
  </a>;
};

export default AmpliObrasLink;
